import React, {Component} from "react";
import Section from "./../layouts/Section";
import {Link} from "react-router-dom";
import PackageExpired from "../layouts/PackageExpired";
import {post} from './../../networking/Api'
import Constent from './../../networking/Constent';
import Timeregistration from "./Timeregistration";
import helpers from './../../networking/Helpers';
import {Alert} from "./../../alertServices";
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import {
    PullToRefresh,
    PullDownContent,
    ReleaseContent,
    RefreshContent
  } from "react-js-pull-to-refresh";


class Userlist extends Component {
    constructor(props) {
        super(props);
        this.state={
          user_list:[],
          group_list:[],
          group_id: '*',
          filter_type:'working_hours',
          start_date:'',
          end_date: '',
          date_range:'',
          isUserDetail:false,
          enable_next_button : true,
          puserId:'',
          pname:'',
          pimage:'',
          p_jobtitle:'',
          p_groupname:'',
          total_paid_time: '00:00',
          total_break_time: '00:00',
          emp_edit : 1,
          total_count: -1
        }
    }
    componentDidMount(){
     this.fetchDetail();
     this.handleRefresh = this.handleRefresh.bind(this);   
    }

    fetchDetail (resolve) {
        let timestamp_option= localStorage.getItem('timestamp_option');
        let timesoption=JSON.parse(timestamp_option);
        let startDate=timesoption.date_range.start_date;
        let endDate=timesoption.date_range.end_date;
        var str=startDate;
        str= str.split(" - "); //convert 'jQuery' to array
        str = str.reverse(); //reverse 'jQuery' order 
        str = str.join(" - ");
        var strs=endDate;
        strs= strs.split(" - "); //convert 'jQuery' to array
        strs = strs.reverse(); //reverse 'jQuery' order 
        strs = strs.join(" - ");
        this.setState({start_date:str,end_date:strs});
        
        this.getTimeStampList(startDate,endDate,this.state.group_id,this.state.filter_type);
        this.enableNextButton(endDate);
        if(timesoption.date_filter==="monthly"){
            this.setState({date_range:30})
        }
        if(timesoption.date_filter==="weekly"){
            this.setState({date_range:7})
        }
        if(timesoption.date_filter==="2_weekly"){
            this.setState({date_range:14})
        }
        if(timesoption.date_filter==="3_monthly"){
            this.setState({date_range:90})
        }

        if(localStorage.getItem('user_type') === 'guest'){  
         this.setState({
            emp_edit:timesoption.guest_setting.emp_edit
          });
        }
            
        this.getAllGroups(resolve);
    }

    handleRefresh() {
        return new Promise(resolve => {
            this.fetchDetail(resolve);
        });
      }

    enableNextButton(endDate){
        var todayDate = helpers.getCurrentDate();

        endDate = moment(endDate, 'YYYY-MM-DD');
        todayDate = moment(todayDate, 'YYYY-MM-DD');
        if (endDate.isBefore(todayDate)) {
            this.setState({'enable_next_button':true});
        }else{
            this.setState({'enable_next_button':false});
        }
    }

    getTimeStampList(start,end,group_id,filter_type){
      var formData=new FormData();
      formData.append("department_id",localStorage.getItem('department_id'));
      formData.append("start_date",start);
      formData.append("end_date",end);
      formData.append("group_id",group_id);
      formData.append("filter_type",filter_type);
      post(Constent.TIMESTAMPLIST,formData).then(response=>{
          if(response.status===1){
            var str=response.startDate;
            str= str.split("-"); //convert 'jQuery' to array
            str = str.reverse(); //reverse 'jQuery' order 
            str = str.join("-");
            var strs=response.endDate;
            strs= strs.split("-"); //convert 'jQuery' to array
            strs = strs.reverse(); //reverse 'jQuery' order 
            strs = strs.join("-");
            this.setState({
                start_date:str,
                end_date:strs,
                user_list:response.users,
                total_count:response.users.length,
                total_paid_time:response.total_paid_time,
                total_break_time:response.total_break_time,
            })
            this.enableNextButton(strs);
          }
      })
    }

    startdt=()=>{
        var str=this.state.start_date;
        str= str.split("-"); //convert 'jQuery' to array
        str = str.reverse(); //reverse 'jQuery' order 
        str = str.join("/");
        return str;
    }
    enddt=()=>{
        var str=this.state.end_date;
        str= str.split("-"); //convert 'jQuery' to array
        str = str.reverse(); //reverse 'jQuery' order 
        str = str.join("/");
        return str;
    }

    getAllGroups(resolve){
        var department_id= localStorage.getItem('department_id');
        var formData = new FormData();
        formData.append("department_id",department_id);
        post(Constent.GETALLGROUPS,formData).then(response=>{
          if(response.status){
            this.setState({group_list:response.data});
          }else{
            Alert.error({title: response.message});
          }
          if(resolve) {
            resolve();
          }
        })
    }

    selectDropdown = (group_id) => {
        this.setState({group_id:group_id});
        this.getTimeStampList(this.state.start_date,this.state.end_date,group_id,this.state.filter_type);
    };

    sortByDropdown = (type) => {
        console.log(type);
        this.setState({filter_type:type});
        this.getTimeStampList(this.state.start_date,this.state.end_date,this.state.group_id,type);
    };

    render() {
        const { t } = this.props;
        if(this.state.isUserDetail){
          return <Timeregistration p_name={this.state.pname} p_image={this.state.pimage} p_userid={this.state.puserId} p_groupname={this.state.p_groupname} p_jobtitle={this.state.p_jobtitle} sdate={this.state.start_date} endDate={this.state.end_date} previousPage={t('lang.timestamp_sc_timeregistration_userlist')} />
        }
        return (
            <Section title={t('lang.menu_name_time_registration')}>
                { helpers.isIntegrationExpired(2) ? <PackageExpired /> : '' }
                <div className="timeregistraion-userlistpage page-title mg-top-50">
                    <div className="container">
                        <div className="row action-row">
                            <div className="col-6">
                                <p className="period">
                                    {/* {t('lang.filter_text_period')}: */}
                                     { this.startdt().substring(0, 5)} - {this.enddt().substring(0, 5)}
                                   &nbsp;&nbsp; <i className="las la-calendar" style={{fontSize:23}} data-toggle="modal" data-target="#calendar-modal"></i>
                                </p>
                            </div>
                            <div className="col-6 text-right">
                                <p className="label" htmlFor="sortBy">{t('lang.filter_text_sorting_by')}</p>
                            </div>
                        </div>
                        <div className="row action-row">
                            <div className="col-6">
                                <span className="previous"
                                onClick={() => {
                                  this.setState({end_date:this.state.start_date});    
                                  var date1 = new Date(this.state.start_date);
                                    date1.setDate(date1.getDate()-this.state.date_range);
                                    var neweDate=date1.toISOString();
                                    neweDate=neweDate.split("T");
                                    this.setState({start_date:neweDate[0]});
                                    this.getTimeStampList(neweDate[0],this.state.start_date, this.state.group_id,this.state.filter_type);
                                    }}>{t('lang.filter_text_prev')}</span>
                                {this.state.enable_next_button === true ?    
                                <span className="next"
                                    onClick={() => {
                                    var date1 = new Date(this.state.end_date);
                                    date1.setDate(date1.getDate() + this.state.date_range)
                                    var neweDate=date1.toISOString();
                                    neweDate=neweDate.split("T");
                                    this.setState({end_date:neweDate[0]});
                                    this.getTimeStampList(this.state.end_date,neweDate[0],this.state.group_id,this.state.filter_type);
                                    }}>{t('lang.filter_text_next')}</span> : ''}
                            </div>
                            <div className="col-6 text-right">
                                <select id="sortBy" 
                                value={this.state.filter_type}
                                onChange={e => { this.sortByDropdown(e.target.value)}} >     
                                    <option value="status">{t('lang.common_text_status')}</option>
                                    <option value="group">{t('lang.common_text_group')}</option>
                                    <option value="role">{t('lang.employee_sc_role')}</option>
                                    <option value="working_hours">{t('lang.common_text_working_hours')}</option>
                                    <option value="name">{t('lang.employee_sc_name')}</option>
                                </select>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="timeregistraion-userlistpage transaction-area mg-bottom-40">
                        <select className="form-control" style={{background:'#E6E6E6',broder:'1px solid #CCCCCC',paddingLeft: 20}}
                        onChange={e => { this.selectDropdown(e.target.value)}}>
                        {this.state.group_list.map(({ id, group_name }) => (
                            <option value={id} key={id}>{(id === '*' ? t('lang.common_text_all_employees') : group_name ) }</option>
                        ))}
                        </select>

                    {/* START */}
                    <PullToRefresh
                        pullDownContent={<PullDownContent label='' />}
                        releaseContent={false}
                        refreshContent={<RefreshContent />}
                        pullDownThreshold={2}
                        onRefresh={this.handleRefresh}
                        triggerHeight={500}
                        startInvisible= {true}
                    >   
                        {this.state.total_count < 0 ? <p className="text-center">{t('lang.common_text_loading') }</p> : '' }
                        <ul className="transaction-inner" style={{marginTop:20}}>
                        {this.state.user_list.map(({ user_id, group_name, job_title,emp_id,full_name,image, total_time,meetdate,leavedate,index}) => (
                            <li className="ba-single-transaction" key={user_id}
                             onClick={()=> this.setState({isUserDetail:true, puserId:user_id, pname:full_name, pimage:image, p_groupname:group_name, p_jobtitle:job_title})} >
                                <div className="row" style={{width:'100%'}}>
                                    <div className="col-3 pd-right-0">
                                        <img src={image} alt="img" style={{width:50,height:50}} />
                                    </div>
                                    <div className="col-5">
                                        <h6 className="text-overflow">{full_name}</h6>
                                        <p>{group_name}</p>
                                        <p>{job_title}</p>
                                    </div>
                                    <div className="col-4 text-right">
                                    {(meetdate==="") ?
                                      <p className="not-working"> <i className="fa fa-circle"></i> {t('lang.flex_sc_free')}</p>
                                    : <p className="working"> <i className="fa fa-circle"></i> {t('lang.flex_sc_working')}</p>
                                    }
                                      <p>{meetdate}</p>
                                      <p className="hours">{t('lang.common_text_hours')}: <strong>{total_time}</strong></p>
                                    </div>
                                </div>
                            </li>
                        ))}
                        </ul>
                    {/* END */}
                    </PullToRefresh>

                </div>
                {/* transaction End */}

                {/* Footer start */}
                <div className="footer-area">
                    <div className="container">
                        <div className="footer-bottom text-center">
                            <div className="row center">
                               <div className="col-8 offset-2">
                                    <div><span>{t('lang.timestamp_sc_paid_time')}:  {this.state.total_paid_time} </span></div>
                                    <div><span>{t('lang.timestamp_sc_break_time')}: {this.state.total_break_time} </span></div>
                                </div>
                                <div className="col-2">
                                    <Link className="home-clicked" to={'/'}>
                                        <i className="fa fa-home" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Footer End */}

                {/*  calendar-modal start */}
                <div id="calendar-modal" className="modal fade" style={{top: 0,bottom: 'auto'}}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{t('lang.timestamp_choose_date_interval')}</h5>
                               
                                <div className="modal-close" data-dismiss="modal">
                                    <i className="la la-times" />
                                </div>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="input-group col-6">
                                        <input type="date" value={this.state.start_date} className="datecalander form-control"
                                        onChange={e => { this.setState({start_date: e.target.value}); }}/>
                                    </div>
                                    <div className="input-group col-6">
                                        <input type="date" value={this.state.end_date} className="datecalander form-control"
                                        onChange={e => { this.setState({end_date: e.target.value}); }}/>
                                    </div>
                                </div>  
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn-c btn-success btn-block" onClick={()=>{this.getTimeStampList(this.state.start_date, this.state.end_date,this.state.group_id,this.state.filter_type); window['modalClose']();}}>{t('lang.common_text_apply')}</button>
                            </div>  
                        </div>  
                    </div>     
                </div>
            </Section>
        );
    }
}

export default withTranslation('common')(Userlist);